/*
 *   Copyright (c) 2025 LoginID Inc
 *   All rights reserved.

 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at

 *   http://www.apache.org/licenses/LICENSE-2.0

 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import { Group, Anchor, Text } from "@mantine/core";

export function Footer() {
  return (
    <Group
      justify="space-between"
      align="center"
      pos="absolute"
      bottom={0}
      mt="lg"
      mb="sm"
    >
      <Text size="xs" fw={500}>
        Copyright 2025
      </Text>
      <Anchor
        size="xs"
        fw={500}
        href="http://loginid.io/privacy-notice"
        target="_blank"
      >
        Privacy policy
      </Anchor>
    </Group>
  );
}
